import {isMobile} from 'react-device-detect';
import {
    getPlannerLayout,
    PlannerLayout,
} from 'components/customer/RoomPlanner/helpers/plannerLayout';
import {
    useIsMobileLandscape,
    useIsPortraitDevices,
} from 'shared/helpers/DeviceSize';

export const usePlannerLayout = (): PlannerLayout => {
    const isPortraitDevices = useIsPortraitDevices();
    const isMobileLandscape = useIsMobileLandscape();

    return getPlannerLayout({
        isMobileUserAgent: isMobile,
        isPortraitDevices,
        isMobileLandscape,
    });
};
